(function () {
  if (window.__fastplusCartWidgetReady) return;
  window.__fastplusCartWidgetReady = true;

  const CART_KEY = 'fastplus_local_cart';
  const PRODUCTS = new Map((window.FASTPLUS_PRODUCTS || []).map((product) => [product.id, product]));
  const GRITS = [40, 60, 80, 100, 120, 150, 180, 220, 240, 320, 400, 600, 800, 1000, 1200, 1500, 2000, 2500, 3000, 4000, 5000];
  const hostSelector = '.site-nav-cta, .nav-cta';
  const CATALOG_FOCUS_KEY = 'fastplus_focus_catalog_search';

  function readCart() {
    try {
      const raw = localStorage.getItem(CART_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  function writeCart(cart) {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    window.dispatchEvent(new Event('fastplus-cart-change'));
  }

  function priceNumber(value) {
    const match = String(value || '').match(/[\d,.]+/);
    return match ? Number(match[0].replace(/,/g, '')) : 0;
  }

  function formatUsd(value) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  }

  function cartQuantity(cart) {
    return cart.reduce((total, item) => total + (Number(item.qty) || 0), 0);
  }

  function cartSubtotal(cart) {
    return cart.reduce((sum, item) => sum + (priceNumber(item.price) * (Number(item.qty) || 0)), 0);
  }

  function normalizeGrit(value) {
    const text = String(value || '').trim();
    const pMatch = text.match(/P(\d{2,4})/i);
    if (pMatch) return `P${pMatch[1]}`;
    const exactMatch = text.match(/^(\d{2,4})$/);
    if (exactMatch) return `P${exactMatch[1]}`;
    return text;
  }

  function parseGritNumbers(value) {
    const text = String(value || '');
    const pMatches = Array.from(text.matchAll(/P(\d{2,4})/gi)).map((match) => Number(match[1]));
    if (pMatches.length) return pMatches;
    const equivalentRange = text.match(/Equivalent\s+(\d{2,4})\s*-\s*(\d{2,4})/i);
    if (equivalentRange) return [Number(equivalentRange[1]), Number(equivalentRange[2])];
    const rangeMatch = text.match(/^(\d{2,4})\s*-\s*(\d{2,4})$/);
    if (rangeMatch) return [Number(rangeMatch[1]), Number(rangeMatch[2])];
    return [];
  }

  function buildGritOptions(product, currentGrit = '') {
    const values = parseGritNumbers(product?.grit);
    let options = [];

    if (values.length === 1) {
      options = [`P${values[0]}`];
    } else if (values.length >= 2) {
      const min = Math.min(...values);
      const max = Math.max(...values);
      options = GRITS.filter((grit) => grit >= min && grit <= max).map((grit) => `P${grit}`);
    }

    const current = normalizeGrit(currentGrit);
    if (current) options.unshift(current);
    if (!options.length) {
      const fallback = normalizeGrit(product?.grit);
      if (fallback) options.push(fallback);
    }

    return Array.from(new Set(options.filter(Boolean)));
  }

  function findCartItemIndex(cart, id, grit = '') {
    return cart.findIndex((item) => item.id === id && (item.grit || '') === (grit || ''));
  }

  function updateCartEntry(cart, id, grit, mutator) {
    const index = findCartItemIndex(cart, id, grit);
    if (index < 0) return cart;
    const next = mutator(cart[index], index, cart);
    if (next === null) {
      cart.splice(index, 1);
      return cart;
    }
    if (next && next !== cart[index]) {
      cart[index] = next;
    }
    return cart;
  }

  function removeCartEntry(cart, id, grit) {
    const index = findCartItemIndex(cart, id, grit);
    if (index >= 0) cart.splice(index, 1);
    return cart;
  }

  function mergeCartGrit(cart, id, oldGrit, newGrit) {
    const normalizedOld = oldGrit || '';
    const normalizedNew = newGrit || '';
    if (normalizedOld === normalizedNew) return cart;

    const sourceIndex = findCartItemIndex(cart, id, normalizedOld);
    if (sourceIndex < 0) return cart;

    const targetIndex = findCartItemIndex(cart, id, normalizedNew);
    if (targetIndex >= 0 && targetIndex !== sourceIndex) {
      cart[targetIndex].qty += cart[sourceIndex].qty;
      cart.splice(sourceIndex, 1);
      return cart;
    }

    cart[sourceIndex].grit = normalizedNew;
    return cart;
  }

  function injectStyles() {
    if (document.getElementById('fp-cart-widget-styles')) return;
    const style = document.createElement('style');
    style.id = 'fp-cart-widget-styles';
    style.textContent = `
      .fp-cart-host {
        display: flex;
        align-items: center;
        margin-left: auto;
        position: relative;
        min-width: 0;
      }
      .fp-cart-shell {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        isolation: isolate;
      }
      .fp-cart-backdrop {
        position: fixed;
        inset: 0;
        display: none;
        border: 0;
        padding: 0;
        margin: 0;
        background: rgba(7,19,38,.34);
        backdrop-filter: blur(2px);
        opacity: 0;
        transition: opacity .18s ease;
        z-index: 55;
        cursor: default;
      }
      .fp-cart-shell.is-open .fp-cart-backdrop {
        display: none;
        opacity: 0;
      }
      .fp-cart-shell.is-open .fp-cart-panel {
        display: block;
      }
      body.fp-cart-lock {
        overflow-y: auto;
      }
      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }
      .fp-cart-button {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        height: 42px;
        padding: 0;
        border-radius: 999px;
        border: 1px solid rgba(44,95,178,.10);
        background:
          linear-gradient(180deg, rgba(255,255,255,.98) 0%, rgba(246,249,255,.96) 100%);
        color: var(--c-blue, #2C5FB2);
        box-shadow:
          0 8px 18px rgba(23,45,90,.06),
          inset 0 1px 0 rgba(255,255,255,.92);
        backdrop-filter: blur(10px);
        cursor: pointer;
        transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease, background .18s ease, color .18s ease;
      }
      .fp-search-button {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        height: 42px;
        padding: 0;
        border-radius: 999px;
        border: 1px solid rgba(35,53,86,.08);
        background:
          linear-gradient(180deg, rgba(255,255,255,.98) 0%, rgba(247,250,254,.97) 100%);
        color: var(--c-navy, #18314A);
        box-shadow:
          0 8px 18px rgba(23,45,90,.05),
          inset 0 1px 0 rgba(255,255,255,.94);
        backdrop-filter: blur(10px);
        cursor: pointer;
        transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease, color .18s ease;
      }
      .fp-search-button:focus-visible {
        outline: 3px solid rgba(44,95,178,.18);
        outline-offset: 3px;
      }
      .fp-search-button:hover {
        transform: translateY(-1px);
        border-color: rgba(35,53,86,.18);
        box-shadow:
          0 14px 28px rgba(23,45,90,.08),
          inset 0 1px 0 rgba(255,255,255,.98);
        color: var(--c-blue, #2C5FB2);
      }
      .fp-search-button:active {
        transform: translateY(0);
        box-shadow:
          0 8px 18px rgba(23,45,90,.06),
          inset 0 1px 0 rgba(255,255,255,.92);
      }
      .fp-search-icon {
        width: 17px;
        height: 17px;
        flex: 0 0 17px;
        opacity: .92;
      }
      .fp-cart-button:focus-visible {
        outline: 3px solid rgba(44,95,178,.18);
        outline-offset: 3px;
      }
      .fp-cart-button:hover {
        transform: translateY(-1px);
        border-color: rgba(44,95,178,.22);
        box-shadow:
          0 14px 28px rgba(23,45,90,.09),
          inset 0 1px 0 rgba(255,255,255,.98);
      }
      .fp-cart-button:active {
        transform: translateY(0);
        box-shadow:
          0 8px 18px rgba(23,45,90,.08),
          inset 0 1px 0 rgba(255,255,255,.9);
      }
      .fp-cart-icon {
        width: 18px;
        height: 18px;
        flex: 0 0 18px;
        opacity: .96;
      }
      .fp-cart-badge {
        position: absolute;
        top: -7px;
        right: -7px;
        min-width: 20px;
        height: 20px;
        border-radius: 999px;
        padding: 0 4px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(180deg, #2C5FB2 0%, #234C92 100%);
        color: #fff;
        font-size: 10px;
        font-weight: 800;
        box-shadow: 0 8px 16px rgba(44,95,178,.22);
        border: 2px solid #fff;
      }
      .fp-cart-panel {
        display: none;
        position: absolute;
        right: 0;
        top: calc(100% + 12px);
        width: min(390px, calc(100vw - 24px));
        padding: 18px;
        border-radius: 22px;
        background: #fff;
        border: 1px solid rgba(218,227,239,.96);
        box-shadow: 0 28px 70px rgba(24,41,76,.18);
        z-index: 60;
      }
      .fp-cart-panel.is-open {
        display: block;
      }
      @media (min-width: 861px) {
        .fp-cart-shell.is-open .fp-cart-backdrop {
          display: none;
        }
        .fp-cart-panel {
          position: fixed;
          top: 96px;
          right: 20px;
          bottom: auto;
          width: min(390px, calc(100vw - 40px));
          max-height: calc(100vh - 116px);
          flex-direction: column;
          overflow: hidden;
          overscroll-behavior: contain;
          z-index: 1300;
        }
        .fp-cart-panel.is-open {
          display: flex;
        }
        .fp-cart-head,
        .fp-cart-actions {
          flex: 0 0 auto;
        }
        .fp-cart-list {
          flex: 0 1 auto;
          min-height: 0;
          max-height: min(44vh, 420px);
          overflow-y: auto;
        }
      }
      .fp-cart-head {
        display: flex;
        justify-content: space-between;
        gap: 16px;
        align-items: flex-start;
        margin-bottom: 12px;
      }
      .fp-cart-head-actions {
        display: flex;
        align-items: flex-start;
        gap: 8px;
      }
      .fp-cart-head strong,
      .fp-cart-total strong {
        color: var(--c-navy, #18314A);
      }
      .fp-cart-head strong {
        display: block;
        font-size: 16px;
      }
      .fp-cart-head span,
      .fp-cart-total span {
        display: block;
        color: #667385;
        font-size: 12px;
        margin-top: 3px;
      }
      .fp-cart-total {
        text-align: right;
      }
      .fp-cart-total strong {
        font-size: 18px;
      }
      .fp-cart-clear {
        display: block;
        margin: 5px 0 0 auto;
        padding: 2px 0;
        border: 0;
        background: transparent;
        color: #667385;
        font-size: 11px;
        font-weight: 800;
        text-decoration: underline;
        text-underline-offset: 3px;
        cursor: pointer;
      }
      .fp-cart-clear:hover:not(:disabled) {
        color: #C05A2B;
      }
      .fp-cart-clear:focus-visible {
        outline: 2px solid rgba(44,95,178,.28);
        outline-offset: 3px;
        border-radius: 2px;
      }
      .fp-cart-clear:disabled {
        color: #A6B0BD;
        cursor: not-allowed;
        text-decoration: none;
      }
      .fp-cart-close {
        width: 32px;
        height: 32px;
        border: 0;
        border-radius: 999px;
        background: #F1F5FB;
        color: var(--c-navy, #18314A);
        font-size: 18px;
        line-height: 1;
        font-weight: 700;
        cursor: pointer;
      }
      .fp-cart-list {
        display: grid;
        gap: 10px;
        max-height: 320px;
        overflow: auto;
        padding-right: 4px;
      }
      .fp-cart-item {
        display: grid;
        grid-template-columns: 52px minmax(0, 1fr);
        gap: 10px;
        align-items: start;
        padding: 10px;
        border-radius: 16px;
        background: #f8fbff;
        border: 1px solid rgba(218,227,239,.92);
      }
      .fp-cart-item img {
        width: 52px;
        height: 52px;
        object-fit: contain;
        border-radius: 12px;
        background: linear-gradient(180deg, #fff 0%, #f1f6fd 100%);
        padding: 6px;
      }
      .fp-cart-item strong {
        display: block;
        color: var(--c-navy, #18314A);
        font-size: 13px;
        line-height: 1.35;
        margin-bottom: 3px;
      }
      .fp-cart-item span,
      .fp-cart-item small {
        display: block;
        line-height: 1.4;
      }
      .fp-cart-item span {
        color: #667385;
        font-size: 12px;
      }
      .fp-cart-item-total {
        margin-left: auto;
        color: var(--c-navy, #18314A);
        font-size: 12px;
        font-weight: 800;
      }
      .fp-cart-item small {
        color: #7B8798;
        font-size: 11px;
        font-weight: 700;
        margin-top: 3px;
      }
      .fp-cart-item-body {
        min-width: 0;
      }
      .fp-cart-item-meta {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 10px;
        margin-top: 8px;
        align-items: center;
        justify-content: space-between;
      }
      .fp-cart-grit {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr);
        align-items: center;
        gap: 8px;
        width: 100%;
      }
      .fp-cart-grit label {
        color: #7B8798;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: .08em;
        text-transform: uppercase;
      }
      .fp-cart-grit select {
        width: 100%;
        min-width: 0;
        height: 34px;
        border-radius: 10px;
        border: 1px solid rgba(44,95,178,.16);
        background: #fff;
        color: var(--c-navy, #18314A);
        font-size: 12px;
        font-weight: 700;
        padding: 0 10px;
        outline: none;
      }
      .fp-cart-grit select:focus {
        border-color: rgba(44,95,178,.42);
        box-shadow: 0 0 0 3px rgba(44,95,178,.10);
      }
      .fp-cart-controls {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 10px;
        align-items: center;
        justify-content: space-between;
      }
      .fp-cart-qty-box {
        min-width: 116px;
        height: 34px;
        padding: 0 4px;
        border-radius: 999px;
        background: #fff;
        border: 1px solid rgba(44,95,178,.14);
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
      }
      .fp-cart-qty-box .qty-btn {
        width: 26px;
        height: 26px;
        border: 0;
        border-radius: 999px;
        background: #EDF4FE;
        color: var(--c-blue, #2C5FB2);
        font-size: 15px;
        font-weight: 800;
      }
      .fp-cart-qty-value {
        min-width: 26px;
        text-align: center;
        color: var(--c-navy, #18314A);
        font-size: 12px;
        font-weight: 800;
      }
      .fp-cart-remove {
        border: 0;
        background: transparent;
        color: #7B8798;
        font-size: 12px;
        font-weight: 800;
        cursor: pointer;
        padding: 8px 4px;
      }
      .fp-cart-remove:hover {
        color: #C05A2B;
      }
      .fp-cart-empty {
        padding: 18px 14px;
        border-radius: 16px;
        background: #f8fbff;
        border: 1px solid rgba(218,227,239,.92);
        color: #667385;
        font-size: 13px;
        line-height: 1.55;
      }
      .fp-cart-actions {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        margin-top: 14px;
      }
      .fp-cart-actions .btn {
        flex: 1 1 0;
        min-width: 0;
        text-align: center;
      }
      @media (max-width: 1024px) {
        .fp-cart-host {
          margin-left: 0;
        }
      }
      @media (max-width: 860px) {
        .fp-search-button,
        .fp-cart-button {
          width: 40px;
          height: 40px;
        }
        .fp-cart-panel {
          position: fixed;
          left: 12px;
          right: 12px;
          top: auto;
          bottom: max(12px, env(safe-area-inset-bottom, 0px));
          width: auto;
          height: auto;
          max-height: calc(100vh - 24px);
          box-sizing: border-box;
          flex-direction: column;
          overflow: hidden;
          padding: 16px;
          border-radius: 18px;
          z-index: 1300;
        }
        .fp-cart-panel.is-open {
          display: flex;
        }
        .fp-cart-head,
        .fp-cart-actions {
          flex: 0 0 auto;
        }
        .fp-cart-list {
          flex: 0 1 auto;
          min-height: 0;
          max-height: min(58vh, 520px);
          overflow-y: auto;
          overscroll-behavior: contain;
        }
      }
      html.fp-mobile-nav-ready .fp-mobile-nav-toggle {
        display: none;
      }
      .fp-mobile-nav-toggle {
        display: none;
        align-items: center;
        gap: 8px;
        height: 40px;
        min-width: 40px;
        padding: 0 12px;
        margin-right: 0;
        border: 1px solid rgba(44,95,178,.12);
        border-radius: 999px;
        background:
          linear-gradient(180deg, rgba(255,255,255,.98) 0%, rgba(246,249,255,.96) 100%);
        color: var(--c-navy, #18314A);
        box-shadow:
          0 8px 18px rgba(23,45,90,.06),
          inset 0 1px 0 rgba(255,255,255,.92);
        cursor: pointer;
        transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease, background .18s ease;
      }
      .fp-mobile-nav-toggle:hover {
        transform: translateY(-1px);
        border-color: rgba(44,95,178,.18);
        box-shadow:
          0 14px 28px rgba(23,45,90,.08),
          inset 0 1px 0 rgba(255,255,255,.98);
      }
      .fp-mobile-nav-toggle:focus-visible {
        outline: 3px solid rgba(44,95,178,.18);
        outline-offset: 3px;
      }
      .fp-mobile-nav-bars {
        width: 16px;
        display: inline-grid;
        gap: 3px;
      }
      .fp-mobile-nav-bars span {
        display: block;
        width: 16px;
        height: 2px;
        border-radius: 999px;
        background: currentColor;
      }
      .fp-mobile-nav-label {
        font-size: 13px;
        font-weight: 800;
      }
      .fp-mobile-nav-backdrop {
        position: fixed;
        inset: 0;
        border: 0;
        padding: 0;
        margin: 0;
        background: rgba(8,15,30,.42);
        backdrop-filter: blur(2px);
        opacity: 0;
        pointer-events: none;
        transition: opacity .2s ease;
        z-index: 1180;
      }
      .fp-mobile-nav-backdrop.is-open {
        opacity: 1;
        pointer-events: auto;
      }
      .fp-mobile-nav-drawer {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        width: min(388px, 92vw);
        transform: translateX(102%);
        transition: transform .28s var(--fastplus-motion-ease);
        z-index: 1190;
        pointer-events: none;
      }
      .fp-mobile-nav-drawer.is-open {
        transform: translateX(0);
        pointer-events: auto;
      }
      .fp-mobile-nav-panel {
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        box-shadow: -20px 0 60px rgba(23,45,90,.18);
      }
      .fp-mobile-nav-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 18px 18px 14px;
        border-bottom: 1px solid rgba(218,227,239,.92);
        position: sticky;
        top: 0;
        background: inherit;
        z-index: 1;
      }
      .fp-mobile-nav-brand {
        display: flex;
        align-items: center;
        gap: 10px;
        min-width: 0;
      }
      .fp-mobile-nav-brand .logo,
      .fp-mobile-nav-brand .site-logo {
        padding-right: 0;
      }
      .fp-mobile-nav-brand img {
        height: 32px;
        width: auto;
      }
      .fp-mobile-nav-close {
        width: 36px;
        height: 36px;
        border: 0;
        border-radius: 999px;
        background: #EFF4FB;
        color: var(--c-navy, #18314A);
        font-size: 22px;
        line-height: 1;
        font-weight: 700;
        cursor: pointer;
      }
      .fp-mobile-nav-scroll {
        flex: 1;
        overflow: auto;
        padding: 6px 18px 22px;
      }
      .fp-mobile-nav-stack {
        display: grid;
        gap: 0;
      }
      .fp-mobile-nav-group {
        padding: 12px 0;
        border: 0;
        border-bottom: 1px solid rgba(218,227,239,.92);
        border-radius: 0;
        background: transparent;
        box-shadow: none;
      }
      .fp-mobile-nav-group-head {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .fp-mobile-nav-parent {
        flex: 1;
        color: var(--c-navy, #18314A);
        font-size: 14px;
        font-weight: 800;
        text-decoration: none;
      }
      .fp-mobile-nav-parent.active {
        color: var(--c-blue, #2C5FB2);
      }
      .fp-mobile-nav-expand {
        width: 34px;
        height: 34px;
        border: 0;
        border-radius: 999px;
        background: #EDF4FE;
        color: var(--c-blue, #2C5FB2);
        font-size: 18px;
        font-weight: 800;
        cursor: pointer;
      }
      .fp-mobile-nav-children {
        display: grid;
        gap: 0;
        padding: 8px 0 2px;
      }
      .fp-mobile-nav-section-title {
        margin-top: 6px;
        color: #7B8798;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: .12em;
        text-transform: uppercase;
      }
      .fp-mobile-nav-link {
        display: flex;
        align-items: center;
        gap: 10px;
        min-height: 42px;
        padding: 9px 8px;
        border-radius: 4px;
        text-decoration: none;
        color: var(--c-navy, #18314A);
        background: transparent;
        border: 0;
        font-size: 13px;
        font-weight: 700;
      }
      .fp-mobile-nav-link.active {
        border-color: rgba(44,95,178,.24);
        background: rgba(44,95,178,.08);
        color: var(--c-blue, #2C5FB2);
      }
      body.fp-mobile-nav-lock {
        overflow: hidden;
      }
      @media (max-width: 860px) {
        html.fp-mobile-nav-ready header nav,
        html.fp-mobile-nav-ready header .site-nav,
        html.fp-mobile-nav-ready nav,
        html.fp-mobile-nav-ready .site-nav {
          flex-wrap: nowrap;
          gap: 8px;
          height: auto;
          min-height: 64px;
          padding: 10px 0;
          align-items: center;
        }
        html.fp-mobile-nav-ready .fp-mobile-nav-toggle {
          display: inline-flex;
        }
        html.fp-mobile-nav-ready .nav-menu,
        html.fp-mobile-nav-ready .site-nav-menu {
          display: none !important;
        }
      }
      @media (max-width: 560px) {
        html.fp-mobile-nav-ready header nav,
        html.fp-mobile-nav-ready header .site-nav,
        html.fp-mobile-nav-ready nav,
        html.fp-mobile-nav-ready .site-nav {
          min-height: 58px;
          gap: 7px;
          padding: 8px 0;
        }
        .fp-mobile-nav-toggle {
          width: 40px;
          padding: 0;
          justify-content: center;
        }
        .fp-mobile-nav-label {
          display: none;
        }
        .fp-mobile-nav-brand img {
          height: 30px;
          max-width: 118px;
        }
        .fp-mobile-nav-scroll {
          padding-inline: 16px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function buildMobileNavDropdown(dropdown, megaSelector) {
    const sections = [];
    const columns = Array.from(dropdown.querySelectorAll(megaSelector));
    if (columns.length) {
      columns.forEach((column) => {
        const links = Array.from(column.querySelectorAll('a')).filter((link) => link.getAttribute('href'));
        if (!links.length) return;
        sections.push({
          title: (column.querySelector('h4')?.textContent || '').replace(/\s+/g, ' ').trim(),
          links,
        });
      });
      return sections;
    }

    const links = Array.from(dropdown.querySelectorAll('a')).filter((link) => link.getAttribute('href'));
    if (links.length) sections.push({ title: '', links });
    return sections;
  }

  function ensureMobileNav() {
    if (window.__fastplusMobileNavReady) return;

    const nav = document.querySelector('header nav, header .site-nav, header .container > nav, header .container > .site-nav');
    if (!nav) return;

    const menu = nav.querySelector('.site-nav-menu, .nav-menu');
    if (!menu) return;

    window.__fastplusMobileNavReady = true;
    document.documentElement.classList.add('fp-mobile-nav-ready');

    const isSiteNav = !!nav.querySelector('.site-nav-menu');
    const itemSelector = isSiteNav ? '.site-nav-item' : '.nav-item';
    const linkSelector = isSiteNav ? '.site-nav-link' : '.nav-link';
    const dropdownSelector = isSiteNav ? '.site-dropdown' : '.dropdown';
    const megaSelector = isSiteNav ? '.site-mega-col' : '.mega-col';

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'fp-mobile-nav-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    toggle.innerHTML = `
      <span class="fp-mobile-nav-bars" aria-hidden="true"><span></span><span></span><span></span></span>
      <span class="fp-mobile-nav-label">Menu</span>
    `;
    nav.insertBefore(toggle, menu);

    const backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'fp-mobile-nav-backdrop';
    backdrop.setAttribute('aria-label', 'Close menu');

    const drawer = document.createElement('aside');
    drawer.className = 'fp-mobile-nav-drawer';
    drawer.innerHTML = `
      <div class="fp-mobile-nav-panel">
        <div class="fp-mobile-nav-head">
          <div class="fp-mobile-nav-brand"></div>
          <button type="button" class="fp-mobile-nav-close" aria-label="Close menu">×</button>
        </div>
        <div class="fp-mobile-nav-scroll">
          <div class="fp-mobile-nav-stack"></div>
        </div>
      </div>
    `;

    document.body.append(backdrop, drawer);

    const brand = drawer.querySelector('.fp-mobile-nav-brand');
    const closeButton = drawer.querySelector('.fp-mobile-nav-close');
    const stack = drawer.querySelector('.fp-mobile-nav-stack');
    const logo = nav.querySelector('.site-logo, .logo');
    if (logo) {
      brand.appendChild(logo.cloneNode(true));
    } else {
      brand.textContent = 'Fastplus';
    }

    Array.from(menu.children).forEach((item) => {
      if (!item.matches(itemSelector)) return;
      const children = Array.from(item.children);
      const topLink = children.find((node) => node.matches(linkSelector));
      if (!topLink) return;
      const dropdown = children.find((node) => node.matches(dropdownSelector));

      const group = document.createElement('div');
      group.className = 'fp-mobile-nav-group';

      const head = document.createElement('div');
      head.className = 'fp-mobile-nav-group-head';

      const parent = topLink.cloneNode(true);
      parent.classList.add('fp-mobile-nav-parent');
      head.appendChild(parent);

      if (dropdown) {
        const expand = document.createElement('button');
        expand.type = 'button';
        expand.className = 'fp-mobile-nav-expand';
        expand.setAttribute('aria-expanded', 'false');
        expand.setAttribute('aria-label', `Expand ${normalizeText(topLink.textContent)} submenu`);
        expand.textContent = '▾';
        head.appendChild(expand);

        const childrenWrap = document.createElement('div');
        childrenWrap.className = 'fp-mobile-nav-children';
        childrenWrap.hidden = true;

        buildMobileNavDropdown(dropdown, megaSelector).forEach((section) => {
          if (section.title) {
            const title = document.createElement('div');
            title.className = 'fp-mobile-nav-section-title';
            title.textContent = section.title;
            childrenWrap.appendChild(title);
          }

          section.links.forEach((link) => {
            const clone = link.cloneNode(true);
            clone.classList.add('fp-mobile-nav-link');
            childrenWrap.appendChild(clone);
          });
        });

        expand.addEventListener('click', () => {
          const isOpen = childrenWrap.hidden;
          childrenWrap.hidden = !isOpen;
          group.classList.toggle('is-open', isOpen);
          expand.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        group.append(head, childrenWrap);
      } else {
        group.append(head);
      }

      stack.appendChild(group);
    });

    function setOpen(isOpen) {
      drawer.classList.toggle('is-open', isOpen);
      backdrop.classList.toggle('is-open', isOpen);
      document.body.classList.toggle('fp-mobile-nav-lock', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    toggle.addEventListener('click', () => {
      setOpen(!drawer.classList.contains('is-open'));
    });
    backdrop.addEventListener('click', () => setOpen(false));
    closeButton.addEventListener('click', () => setOpen(false));
    drawer.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) {
        setOpen(false);
      }
    });
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 860) {
        setOpen(false);
      }
    });
  }

  function headerHost() {
    let host = document.querySelector(hostSelector);
    if (host) return host;

    const nav = document.querySelector('header nav, header .site-nav, header .container > nav, header .container > .site-nav');
    host = document.createElement('div');
    host.className = 'fp-cart-host';
    if (nav) {
      nav.appendChild(host);
    } else {
      (document.querySelector('header') || document.body).appendChild(host);
    }
    return host;
  }

  function portalCartPanel(panel) {
    if (!panel) return panel;
    panel.dataset.fpCartPortal = 'true';
    if (panel.parentElement !== document.body) document.body.appendChild(panel);
    return panel;
  }

  function cartIcon() {
    return `
      <svg class="fp-cart-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M7.5 8.2V7.1a4.5 4.5 0 0 1 9 0v1.1" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <path d="M5.8 8.4h12.4l-1 10.1a1.6 1.6 0 0 1-1.6 1.5H8.4a1.6 1.6 0 0 1-1.6-1.5l-1-10.1Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
        <path d="M9.2 12.1c.5.6 1.1.9 1.8.9s1.3-.3 1.8-.9c.5.6 1.1.9 1.8.9.7 0 1.2-.2 1.7-.6" stroke="currentColor" stroke-width="1.55" stroke-linecap="round"/>
      </svg>
    `;
  }

  function backdropMarkup() {
    return `
      <button type="button" class="fp-cart-backdrop" data-cart-close aria-label="Close cart"></button>
    `;
  }

  function nativeButtonMarkup() {
    return `
      <button type="button" class="fp-cart-button" id="cart-toggle" aria-expanded="false" aria-controls="cart-preview" aria-label="Open cart">
        ${cartIcon()}
        <span class="fp-cart-badge" id="cart-badge">0</span>
        <span class="sr-only" id="cart-toggle-sub">0 items · $0.00</span>
      </button>
    `;
  }

  function nativePanelMarkup() {
    return `
      <div class="fp-cart-panel" id="cart-preview">
        <div class="fp-cart-head">
          <div>
            <strong>Cart</strong>
            <span id="cart-preview-meta">0 items in your cart</span>
          </div>
          <div class="fp-cart-head-actions">
            <div class="fp-cart-total">
              <span>Subtotal</span>
              <strong id="cart-preview-total">$0.00</strong>
              <button type="button" class="fp-cart-clear" data-cart-action="clear" aria-label="Clear all items from cart">Clear cart</button>
            </div>
            <button type="button" class="fp-cart-close" data-cart-close aria-label="Close cart">×</button>
          </div>
        </div>
        <div class="fp-cart-list" id="cart-preview-list"></div>
        <div class="fp-cart-actions">
          <a href="/pages/all-products#catalog" class="btn btn-outline">Browse Products</a>
          <a href="/cart" class="btn btn-primary">Checkout</a>
        </div>
      </div>
    `;
  }

  function isCatalogPage() {
    return window.location.pathname.toLowerCase().includes('/pages/all-products') ||
      new URLSearchParams(window.location.search).get('view') === 'all-products';
  }

  function focusCatalogSearch() {
    const input = document.getElementById('catalog-search');
    if (!input) return false;
    input.focus({ preventScroll: false });
    if (typeof input.select === 'function') input.select();
    if (typeof input.scrollIntoView === 'function') {
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return true;
  }

  function openCatalogSearch() {
    if (window.FastplusGlobalSearch && typeof window.FastplusGlobalSearch.open === 'function') {
      window.FastplusGlobalSearch.open();
      return;
    }
    window.location.href = '/search';
  }

  function ensureShell() {
    const host = headerHost();
    let shell = document.querySelector('[data-fp-cart-shell]');
    const existingButton = document.getElementById('cart-toggle');
    const existingPanel = document.getElementById('cart-preview');
    const hasNativeCart = existingButton && existingPanel;

    if (hasNativeCart) {
      const sectionCart = document.querySelector('.section-nav-cart');
      if (sectionCart) {
        shell = document.createElement('div');
        shell.dataset.fpCartShell = 'native';
        shell.className = 'fp-cart-shell';
        shell.insertAdjacentHTML('afterbegin', backdropMarkup());
        shell.append(existingButton, existingPanel);
        host.appendChild(shell);
        sectionCart.remove();
      } else {
        const slot = existingButton.closest('.fp-cart-shell') || existingPanel.closest('.fp-cart-shell');
        if (slot && slot.parentElement !== host) {
          host.appendChild(slot);
        }
        if (slot && !slot.querySelector('[data-cart-close]')) {
          slot.insertAdjacentHTML('beforeend', backdropMarkup());
        }
      }

      if (!existingButton.querySelector('.fp-cart-icon')) {
        const icon = document.createElement('span');
        icon.className = 'fp-cart-icon';
        icon.innerHTML = cartIcon();
        existingButton.prepend(icon);
      }

      return {
        shell: shell || existingButton.closest('.fp-cart-shell') || existingPanel.closest('.fp-cart-shell'),
        button: existingButton,
        panel: portalCartPanel(existingPanel),
        native: true
      };
    }

    if (!shell) {
      shell = document.createElement('div');
      shell.dataset.fpCartShell = 'custom';
      shell.className = 'fp-cart-shell';
      shell.innerHTML = backdropMarkup() + nativeButtonMarkup() + nativePanelMarkup();
      host.appendChild(shell);
    }

    if (shell && !shell.querySelector('[data-cart-close]')) {
      shell.insertAdjacentHTML('beforeend', backdropMarkup());
    }

    const panel = portalCartPanel(document.getElementById('cart-preview') || shell.querySelector('#cart-preview'));

    return {
      shell,
      button: shell.querySelector('#cart-toggle'),
      panel,
      native: false
    };
  }

  function renderCustomPanel(panel, cart) {
    const list = panel.querySelector('#cart-preview-list');
    const meta = panel.querySelector('#cart-preview-meta');
    const total = panel.querySelector('#cart-preview-total');
    const clearButton = panel.querySelector('[data-cart-action="clear"]');
    const count = cartQuantity(cart);
    const subtotal = cartSubtotal(cart);
    const buttonBadge = document.getElementById('cart-badge');
    const button = document.getElementById('cart-toggle');

    if (buttonBadge) buttonBadge.textContent = String(count);
    if (buttonBadge && count > 99) buttonBadge.textContent = '99+';
    if (button) button.setAttribute('aria-label', `Open cart, ${count} item${count === 1 ? '' : 's'} in cart, subtotal ${formatUsd(subtotal)}`);
    if (meta) meta.textContent = `${count} item${count === 1 ? '' : 's'} in your cart`;
    if (total) total.textContent = formatUsd(subtotal);
    if (clearButton) clearButton.disabled = count === 0;

    if (!list) return;

    if (!count) {
      list.innerHTML = '<div class="fp-cart-empty">Add products from any page and they will appear here for quick review.</div>';
      return;
    }

    list.innerHTML = cart.slice().reverse().map((item) => {
      const product = PRODUCTS.get(item.id);
      const gritOptions = product ? buildGritOptions(product, item.grit) : [];
      const lineTotal = formatUsd(priceNumber(item.price) * (Number(item.qty) || 0));
      const gritSelect = gritOptions.length ? `
        <div class="fp-cart-grit">
          <label>Grit</label>
          <select data-cart-grit-select>
            ${gritOptions.map((grit) => `<option value="${grit}" ${grit === (item.grit || gritOptions[0]) ? 'selected' : ''}>${grit}</option>`).join('')}
          </select>
        </div>
      ` : '';

      return `
        <div class="fp-cart-item" data-cart-item data-item-id="${item.id}" data-item-grit="${item.grit || ''}">
          <img src="${item.image}" alt="${item.title}">
          <div class="fp-cart-item-body">
            <strong>${item.title}</strong>
            ${item.grit ? `<small>Included grit: ${item.grit}</small>` : ''}
            <div class="fp-cart-item-meta">
              <span>${item.qty} x ${item.price}</span>
              <strong class="fp-cart-item-total">${lineTotal}</strong>
            </div>
            ${gritSelect}
            <div class="fp-cart-controls">
              <div class="fp-cart-qty-box" aria-label="Quantity controls">
                <button type="button" class="qty-btn" data-cart-action="qty" data-delta="-1" aria-label="Decrease quantity">-</button>
                <span class="fp-cart-qty-value">${item.qty}</span>
                <button type="button" class="qty-btn" data-cart-action="qty" data-delta="1" aria-label="Increase quantity">+</button>
              </div>
              <button type="button" class="fp-cart-remove" data-cart-action="remove">Remove</button>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  function updateCustomPanel() {
    const panel = document.getElementById('cart-preview');
    if (!panel) return;
    renderCustomPanel(panel, readCart());
  }

  function setCartOpen(shell, button, panel, isOpen) {
    if (!shell || !button || !panel) return;
    shell.classList.toggle('is-open', isOpen);
    panel.classList.toggle('is-open', isOpen);
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.body.classList.remove('fp-cart-lock');
  }

  function bindCustomCart(shell, button, panel) {
    if (!button || !panel) return;

    const backdrop = shell.querySelector('[data-cart-close]');
    if (backdrop) {
      backdrop.addEventListener('click', () => setCartOpen(shell, button, panel, false));
    }

    button.addEventListener('click', () => {
      const shouldOpen = !panel.classList.contains('is-open');
      setCartOpen(shell, button, panel, shouldOpen);
      if (shouldOpen) updateCustomPanel();
    });

    panel.addEventListener('click', (event) => {
      const action = event.target.closest('[data-cart-action]');
      if (!action) return;

      if (action.dataset.cartAction === 'clear') {
        writeCart([]);
        updateCustomPanel();
        return;
      }

      const itemNode = event.target.closest('[data-cart-item]');
      if (!itemNode) return;

      const itemId = itemNode.dataset.itemId || '';
      const itemGrit = itemNode.dataset.itemGrit || '';
      const cart = readCart();

      if (action.dataset.cartAction === 'remove') {
        removeCartEntry(cart, itemId, itemGrit);
      } else if (action.dataset.cartAction === 'qty') {
        const delta = Number(action.dataset.delta || 0);
        updateCartEntry(cart, itemId, itemGrit, (item) => {
          const nextQty = Math.max(0, (Number(item.qty) || 0) + delta);
          if (!nextQty) return null;
          return { ...item, qty: nextQty };
        });
      }

      writeCart(cart);
      updateCustomPanel();
    });

    panel.addEventListener('change', (event) => {
      const select = event.target.closest('[data-cart-grit-select]');
      const itemNode = event.target.closest('[data-cart-item]');
      if (!select || !itemNode) return;

      const itemId = itemNode.dataset.itemId || '';
      const itemGrit = itemNode.dataset.itemGrit || '';
      const nextGrit = normalizeGrit(select.value);
      const cart = readCart();

      mergeCartGrit(cart, itemId, itemGrit, nextGrit);
      writeCart(cart);
      updateCustomPanel();
    });

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setCartOpen(shell, button, panel, false);
      }
    });
  }

  function init() {
    injectStyles();
    ensureMobileNav();
    const { button, panel, native } = ensureShell();

    if (!button || !panel) return;

    if (native) {
      if (sessionStorage.getItem(CATALOG_FOCUS_KEY) === '1') {
        sessionStorage.removeItem(CATALOG_FOCUS_KEY);
        focusCatalogSearch();
      }
      return;
    }

    updateCustomPanel();
    bindCustomCart(button.closest('[data-fp-cart-shell]'), button, panel);
    if (sessionStorage.getItem(CATALOG_FOCUS_KEY) === '1') {
      sessionStorage.removeItem(CATALOG_FOCUS_KEY);
      focusCatalogSearch();
    }
    window.addEventListener('storage', (event) => {
      if (event.key === CART_KEY) updateCustomPanel();
    });
    window.addEventListener('fastplus-cart-change', updateCustomPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
